module.exports = class TransferShowContainerCtrl
  constructor: (TransferService, $state) ->
    'ngInject'
    @TransferService = TransferService
    @$state = $state

  $onInit: ->
    @transfer = @TransferService.get(@$state.params.transfer_id).$object
